export default __webpack_public_path__ + "static/media/user.cc384a27.png";